<div class="card custom-card my-1 border-0">
  <div class="card-body mb-1">
    <!-- ส่วนหัวฟอร์มค้นหา -->
    <div class="row mb-2">
      <div class="col-12">
        <label class="col-form-label">
          <i class="bi bi-search me-2"></i>
          ค้นหาข้อมูล
        </label>
        <hr class="mt-2">
      </div>
    </div>

    <!-- ฟอร์มค้นหา -->
    <div class="row g-3">
      <!-- ชื่อ-สกุล -->
      <div class="col-12 col-md-6">
        <label for="fullName" class="form-label">
          ชื่อ-สกุล / Name
        </label>
        <input type="text" class="form-control" id="fullName" name="fullName" [(ngModel)]="params().fullName">
      </div>

      <!-- อีเมล -->
      <div class="col-12 col-md-6">
        <label for="email" class="form-label">
          อีเมล / Email
        </label>
        <input type="text" class="form-control" id="email" name="email" [(ngModel)]="params().email">
      </div>

      <!-- ประเภทเจ้าหน้าที่ -->
      <div class="col-12 col-md-6">
        <label for="userType" class="form-label">
          ประเภทเจ้าหน้าที่ / User Type
        </label>
        <select class="form-select" id="userType" [(ngModel)]="params().admin">
          <option [ngValue]="null" selected>--- เลือกทั้งหมด ---</option>
          <option [ngValue]="true">ADMIN</option>
          <option [ngValue]="false">OFFICIAL</option>
        </select>
      </div>

      <!-- สถานะ -->
      <div class="col-12 col-md-6">
        <label for="status" class="form-label">
          สถานะ / Status
        </label>
        <select class="form-select" id="status" [(ngModel)]="params().enable">
          <option [ngValue]="null" selected>--- เลือกทั้งหมด ---</option>
          <option [ngValue]="true">ใช้งาน (Active)</option>
          <option [ngValue]="false">ไม่ใช้งาน (InActive)</option>
        </select>
      </div>
    </div>

    <!-- ปุ่มค้นหาและล้างข้อมูล -->
    <div class="row mt-4 mb-2">
      <div class="col-12 d-flex justify-content-center gap-2 flex-wrap">
        <button type="button" class="btn btn-custom btn-custom-theme" (click)="search()">
          <i class="bi bi-search me-2"></i>
          ค้นหา
        </button>
        <button type="button" class="btn btn-custom btn-light" (click)="clear()">
          <i class="bi bi-arrow-clockwise me-2"></i>
          ล้างข้อมูล
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ส่วนแสดงข้อมูล -->
<div class="card custom-card my-3 border-0">
  <div class="card-body mb-3">
    <!-- หัวข้อตารางและปุ่มเพิ่ม -->
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="mb-2 mb-md-0">
        รายการทั้งหมด {{ pageData()?.totalElements | number }} รายการ
      </div>
      <div>
        <button class="btn btn-custom btn-custom-theme" (click)="openModel('เพิ่ม',null)" *hasAnyRole="['admin']">
          <i class="bi bi-plus-lg me-1"></i>
          <span class="d-none d-md-inline">เพิ่มเจ้าหน้าที่</span>
          <span class="d-inline d-md-none">เพิ่ม</span>
        </button>
      </div>
    </div>

    <!-- ตารางข้อมูล -->
    <div class="table-responsive">
      <table class="table table-striped table-borderless">
        <thead class="color-black font-weight-light">
        <tr class="table-light text-center" style="background-color: #eeeeee;">
          <th scope="col" class="d-none d-md-table-cell">ลำดับ<br>No.</th>
          <th scope="col">จัดการ<br>Manage</th>
          <th scope="col">ชื่อผู้ใช้งาน<br>User Name</th>
          <th scope="col" class="d-none d-md-table-cell">ชื่อ-นามสกุล<br>Name</th>
          <th scope="col" class="d-none d-lg-table-cell">ประเภท<br>Type</th>
          <th scope="col" class="d-none d-lg-table-cell">อีเมล<br>Email</th>
          <th scope="col">สถานะ<br>Status</th>
        </tr>
        </thead>
        <tbody class="table-borderless">
        <tr *ngIf="isLoading">
          <td class="text-muted text-center" colspan="7">
            <app-async-loading></app-async-loading>
          </td>
        </tr>
        <tr *ngIf="!isLoading && !pageData()?.content?.length">
          <td class="text-muted text-center" colspan="7">
            <app-not-found></app-not-found>
          </td>
        </tr>
        <tr *ngFor="let item of pageData()?.content; let i= index">
          <td class="text-center d-none d-md-table-cell">{{(pageData().number*pageData().size)+(i+1)}}</td>
          <td class="text-center pb-1">
            <button class="btn btn-sm btn-default" (click)="openModel('แก้ไข',item)">
              <i class="bi bi-pencil me-1"></i>
            </button>
          </td>
          <td>
            <!-- แสดงข้อมูลหลักและแสดงข้อมูลที่ซ่อนบนมือถือ -->
            <div class="d-flex flex-column">
              <span class="text-center">{{item.userName}}</span>
              <small class="text-muted d-md-none">{{item.fullName}}</small>
              <small class="text-muted d-lg-none">{{item.admin ? 'ADMIN' : 'OFFICIAL'}}</small>
              <small class="text-muted d-lg-none">{{item.email}}</small>
            </div>
          </td>
          <td class="text-center d-none d-md-table-cell">{{item.fullName}}</td>
          <td class="text-center d-none d-lg-table-cell">
            {{item.admin ? 'ADMIN' : 'OFFICIAL'}}
          </td>
          <td class="text-center d-none d-lg-table-cell">{{item.email}}</td>
          <td class="text-center">
              <span [class.text-success]="item.enable" [class.text-danger]="!item.enable">
                <span class="d-none d-md-inline">{{ item.enable ? "เปิดใช้งาน (Active)" : "ปิดใช้งาน (InActive)" }}</span>
                <span class="d-inline d-md-none">{{ item.enable ? "เปิด" : "ปิด" }}</span>
              </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="d-flex justify-content-center mt-3">
      <ngb-pagination
        [maxSize]="5"
        [rotate]="true"
        [ellipses]="false"
        [boundaryLinks]="true"
        [page]="pageData()?.number + 1"
        (pageChange)="search($event)"
        [pageSize]="pageData()?.size"
        [collectionSize]="pageData()?.totalElements">
      </ngb-pagination>
    </div>
  </div>
</div>
